import React from 'react';
import { SSO } from '../../components';

export default function ViewSSO(props) {
  return <SSO {...props} />;
}
